module.exports = __webpack_public_path__ + "img/jo4.35c1cdd5.png";